const $ = window.jQuery;

class Footer {
  constructor() {
    this.selectors = {
      column: '.js-footer-nav-column',
      toggle: '.js-footer-column-toggle',
    };

    this.breakpoint = window.matchMedia('(max-width: 768px)');

    this.classes = {
      open: 'is-open',
    };

    this.toggles = document.querySelectorAll(this.selectors.toggle);

    $(document).ready(() => {
      this.init();
    });
  }

  init() {
    if (!this.toggles.length) {
      return;
    }

    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', e => {
        if (this.breakpoint.matches) {
          e.preventDefault();

          const column = e.currentTarget.closest(this.selectors.column);

          column.classList.toggle(this.classes.open);
        }
      });
    });
  }
}

export default new Footer();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/footer.js